import { Alert, Chip, SxProps, Theme } from "@mui/material";
import { CheckCircle, HourglassEmpty } from "@mui/icons-material";
import { CSSProperties } from "react";
import { IPurchaseOrder } from "../../store/interfaces/IPurchaseOrder";
import { isTalonario } from "../../utils/raffleType";

// Marca para órdenes que todavía no tienen comprobante (ej. talonario apartado sin pago)
export const VOUCHER_PENDING = "VOUCHER_PENDING";

// Solo talonario usa voucherUploaded: en los demás tipos las órdenes antiguas llegan con false aunque tengan comprobante
export const getVoucherImageUrl = (accountId: string, raffleId: string, order: IPurchaseOrder, raffleType?: string) =>
  isTalonario(raffleType) && !order.voucherUploaded
    ? VOUCHER_PENDING
    : `https://storage.googleapis.com/${accountId}/raffles/${raffleId}/vouchers/${order.id}`;

interface VoucherPreviewProps {
  src: string;
  alt?: string;
  style?: CSSProperties;
}

export const VoucherPreview = ({ src, alt = "", style }: VoucherPreviewProps) =>
  src === VOUCHER_PENDING ? (
    <Alert severity="info">Esperando comprobante: la persona aún no lo adjunta.</Alert>
  ) : (
    <img src={src} alt={alt} style={style} />
  );

interface VoucherStatusChipProps {
  order: IPurchaseOrder;
  raffleType?: string;
  sx?: SxProps<Theme>;
}

// Solo talonario: permite ver desde la lista si una orden pendiente ya tiene comprobante
export const VoucherStatusChip = ({ order, raffleType, sx }: VoucherStatusChipProps) => {
  if (!isTalonario(raffleType) || order.status !== "TRANSFER_PAYMENT_CREATED") return null;

  return order.voucherUploaded ? (
    <Chip size="small" color="success" icon={<CheckCircle />} label="Comprobante listo" sx={sx} />
  ) : (
    <Chip size="small" color="warning" icon={<HourglassEmpty />} label="Falta comprobante" sx={sx} />
  );
};
